// Centralized storage cache keys used across the app.

export const CACHE_TABLES = {
  ngrxCache: 'NgrxCache',
  ngrxCacheSchoolClasses: 'NgrxCache-schoolClasses',
  ngrxCacheLocationMembers: 'NgrxCache-locationMembers',
  ngrxCacheSelectedProductTypesAtLocation: 'NgrxCache-selectedProductTypes-by-location',
  ngrxCacheActivePupilUploads: 'ngrxCacheActivePupilUploads',
};

export const CACHE_KEYS = {
  // Entity collection cache entries
  cancellationReasons: 'cancellationReasons',
  clusters: 'clusters',
  locations: 'locations',
  subjects: 'subjects',

  // User-specific/current selection cache keys
  activeLocation: 'active-location',
} as const;

// Prefixes for dynamic keys
export const CACHE_KEY_PREFIX = {
  activeLocationForUser: 'active-location-for-user-',
} as const;
